const ON_CHANGE_DEBOUNCE_TIMER = 300;

// Fixed, device-independent safety budget before navigating away on a tracked product
// click. Not "wait for the request to finish" (no cross-browser signal for that exists
// once GTM owns the transport) — a flat timer that's the same on every device and is
// generous enough for a small analytics beacon to leave the client even on a slow
// connection.
const SELECT_ITEM_NAV_DELAY_MS = 300;

// Quiet period after the last product card becomes visible before view_item_list is sent.
// While scrolling, cards cross the visibility threshold row by row, each in its own
// IntersectionObserver callback; batching them until scrolling settles sends one event
// with all newly seen items instead of one event per row.
const VIEW_ITEM_LIST_BATCH_DELAY_MS = 500;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const ANALYTICS_EVENTS = {
  viewItemList: 'view_item_list',
  viewItem: 'view_item',
  selectItem: 'select_item',
  viewCart: 'view_cart',
  pageView: 'page_view',
  newsletterSubscription: 'newsletter_subscription',
  addToCart: 'add_to_cart',
};
